
import Axios from 'axios';
import textFit from 'textfit';

import { defineComponent } from 'vue'

export default defineComponent({
    name: 'WayfindingLayout' as string,
    data() {
        return {
            item: {} as any,
            liveMessageHandler: null as any,
            liveRevision: 0
        }
    },
    computed: {
        backgroundStyle(): any {
            if (this.item.useBackgroundMedia) {
                if(!this.item.media.asset1_url) {
                    return { background: 'transparent'};
                }
                return { background: `url(${this.item.media.asset1_url}) center center no-repeat`, backgroundSize : 'cover'}
            } else {
                return { background: this.item.backgroundColor }
            }
        }
    },
    props: ['id', 'signature'],
    mounted() {
        // FLOCK-6612: live-preview mode. When loaded by the editor's
        // LiveTemplatePreview iframe (id 'live'), skip the templaterequest
        // fetch and take layout data over postMessage from the parent
        // instead — same-origin only, since this route is unauthenticated
        // for the server-side renderer's benefit. The server render path
        // (real id + signature) is unchanged.
        if (this.id === 'live') {
            this.liveMessageHandler = (event: MessageEvent) => {
                if (event.origin !== window.location.origin) { return; }
                if (event.data && event.data.type === 'ditto-live-preview' && event.data.layoutData) {
                    this.item = { ...event.data.layoutData };
                    this.liveRevision++;
                }
            };
            window.addEventListener('message', this.liveMessageHandler);
            // Handshake: the parent's iframe 'load' event fires before this
            // component mounts, so a message posted then would be lost and
            // the preview would stay empty until the next edit. Announce
            // readiness so the parent knows exactly when to send data.
            if (window.parent && window.parent !== window) {
                window.parent.postMessage({ type: 'ditto-live-preview-ready' }, window.location.origin);
            }
            return;
        }

        return Axios.get(`${ process.env.VUE_APP_API_HOST }/api/signages/${this.id}/templaterequest/${this.signature}`).then((res) => {
            this.item = res.data;
        });
    },

    beforeUnmount() {
        if (this.liveMessageHandler) {
            window.removeEventListener('message', this.liveMessageHandler);
        }
    },
    watch: {
        item() {
            this.$nextTick(() => {
                textFit(document.getElementsByClassName('textfit__waypoints'), { minFontSize: 10, maxFontSize: 150 });
            });
        }
    }
});
